/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { select } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import {
  Asset,
  AssetOptionType,
  AssetUtils,
  Channel,
  Series,
  translate,
  WishlistOption,
} from '@wit/vtv-x-foundation-lib';
import { Selectors as WishlistSelectors } from '../../wishlist';
import { Selectors as ChannelsSelectors } from '../../epg/channels';

function* getOptions(representativeAsset: Asset, series?: Series): SagaIterator<WishlistOption[]> {
  const selectedAsset = series || representativeAsset; // if there is a series object then use it first

  const channels: Channel[] = yield select(ChannelsSelectors.getChannels);

  let channel = AssetUtils.getAssetRelatedChannel(selectedAsset, channels);
  if (!channel && series) {
    channel = AssetUtils.getAssetRelatedChannel(representativeAsset, channels);
  }

  const option: WishlistOption = {
    key: `${AssetOptionType.WISHLIST}`,
    type: AssetOptionType.WISHLIST,
    title: translate['pi.options.wishlist.add'],
    asset: selectedAsset,
    isWishlisted: false,
    channel,
  };

  const listedAsset: boolean = yield select(WishlistSelectors.isAssetWishlisted, selectedAsset);
  if (listedAsset) {
    option.title = translate['pi.options.wishlist.remove'];
    option.isWishlisted = true;
  }

  return [option];
}

export default {
  getOptions,
};
